import { render, staticRenderFns } from "./Step2Method.vue?vue&type=template&id=ab38c3e6&scoped=true&"
import script from "./Step2Method.vue?vue&type=script&lang=js&"
export * from "./Step2Method.vue?vue&type=script&lang=js&"
import style0 from "./Step2Method.vue?vue&type=style&index=0&id=ab38c3e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab38c3e6",
  null
  
)

export default component.exports